import { render, staticRenderFns } from "./PageOrdinaryPackage.vue?vue&type=template&id=813062a8&scoped=true"
import script from "./PageOrdinaryPackage.vue?vue&type=script&lang=js"
export * from "./PageOrdinaryPackage.vue?vue&type=script&lang=js"
import style0 from "./PageOrdinaryPackage.vue?vue&type=style&index=0&id=813062a8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813062a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('813062a8')) {
      api.createRecord('813062a8', component.options)
    } else {
      api.reload('813062a8', component.options)
    }
    module.hot.accept("./PageOrdinaryPackage.vue?vue&type=template&id=813062a8&scoped=true", function () {
      api.rerender('813062a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/goods/audit/sku/components/PageOrdinaryPackage.vue"
export default component.exports